export default __webpack_public_path__ + "static/media/Power.d31125d8.mp3";